import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const url = process.env.REACT_APP_BASE_URL;

// Define a service using a base URL and expected endpoints
export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({ baseUrl: url }),
  endpoints: (builder) => ({}),
  tagTypes: ["User", "Chart"],
});
